module.exports = __webpack_public_path__ + "img/default-photo.18cc5e91.png";